import { IRideDto } from "../dto";
import { CourseRouteTypeEnum } from "../enums";
import { useSystemParams } from "./use-system-params";

/**
 * Determines if a shuttle ride has manual passenger counting enabled.
 *
 * Shuttle rides have no pre-booking, so they normally show no per-station passenger data ("--").
 * When the company enables the driver-app passenger counter (`isPassengerCounterButtonShown`),
 * shuttle rides instead expose the driver's manually-counted boarding passengers per station
 * (`IStationInfo.seatsCountByDriver`). This hook tells the ride profile / edit panel when to
 * switch to that manual-count display.
 */
export const useIsShuttleRideWithManualCount = (
  rideDto?: Partial<IRideDto>,
): boolean => {
  const { isPassengerCounterButtonShown } = useSystemParams();

  return (
    Boolean(isPassengerCounterButtonShown) &&
    rideDto?.metadata?.courseType === CourseRouteTypeEnum.Shuttle
  );
};
